import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LS_COMPLIANCE_SUBMIT_KEY } from '@/helpers/localStorage';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complianceService } from '../../services/complianceService';

export const useSubmitAmlCase = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      complianceService
        .submitCase(payload)
        .then(response => {
          const { status, data } = response;

          if (status === 200) {
            localStorage.setItem(LS_COMPLIANCE_SUBMIT_KEY, '1');
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.compliance.notifications],
            });
            return { data, success: true };
          }

          throw new Error(data?.message);
        })
  });
};
